import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
    & > div > div > div > div > div > table > tbody > tr > td > span:before {
        content: "";
    }

    @media screen and (max-width: 992px) {
        & > div > div > div > div > div > table {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-thead {
            display: none;
        }
        & > div > div > div > div > div > table > .ant-table-tbody {
            width: 100%;
        }
        & > div > div > div > div > div > table > .ant-table-tbody > .ant-table-row {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: flex;
            flex-direction: column;
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
        &
            > div
            > div
            > div
            > div
            > div
            > table
            > .ant-table-tbody
            > .ant-table-row
            > .ant-table-cell {
            border-bottom: 1px solid #f0f0f0;
            padding: 6px 16px !important;
            width: 100%;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
        & > div > div > div > div > div > table > tbody > tr > td > span:before {
            content: attr(data-label);
            font-weight: bold;
            padding-right: 5px;
        }
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const StatDetail = styled.div`
    padding: 6px;
    cursor: pointer;

    &:hover {
        padding: 5px;
        background-color: #f0f0f0;
        border: 1px solid black;
        border-radius: 5px;
    }
`;
